module.exports = __webpack_public_path__ + "img/weather-station.ae68ce49.jpg";